import { useState, memo } from 'react';
import { KeenIcon } from '@/components';
import { AutoTrain } from './autotrain';
import { ManageSuggested } from './ManageSuggestedListing';
import { FormattedMessage } from 'react-intl';
import PropTypes from 'prop-types';

const Suggested = ({ isOpen, onToggle }) => {
  const [isModalOpen, setIsModalOpen] = useState(false);

  return (
    <div>
      <button
        onClick={onToggle}
        className={`w-full flex items-center justify-between py-2 px-4 border border-gray border-opacity-50 
          ${isOpen ? 'bg-gray-200' : 'bg-white'} rounded-md hover:bg-gray-200 transition-colors`}
      >
        <div className='text-sm font-semibold'>
          <KeenIcon icon="note-2" className="mr-2" />
          <FormattedMessage id="AGENTS.BUILDER.SUGGESTED" />
        </div>
        <span className="text-gray-500">
          {isOpen ? <KeenIcon icon="down" /> : <KeenIcon icon="right" />}
        </span>
      </button>

      <div 
        className={`overflow-hidden transition-all duration-300 ease-in-out ${
          isOpen ? 'opacity-100 mt-3' : 'max-h-0 opacity-0'
        }`}
      >
        <div className="space-y-2 border rounded-lg">
          <div className="p-4 rounded-lg flex gap-2 items-center justify-between">
            <button
              onClick={() => setIsModalOpen(true)}
              className="w-full md:w-fit px-4 py-2 bg-gray-100 text-black border-1 border-black rounded hover:bg-gray-300 transition-colors text-sm"
            >
              <FormattedMessage id="AGENTS.HOME.MANAGE" />
            </button>
            <AutoTrain />
          </div>
        </div>
      </div>

      <ManageSuggested
        open={isModalOpen}
        onClose={() => setIsModalOpen(false)}
        type="suggested"
        tableProps={{}}
      />
    </div>
  );
};

const memoSuggested = memo(Suggested)

Suggested.propTypes = {
  isOpen: PropTypes.bool.isRequired,
  onToggle: PropTypes.func.isRequired,
};

export {memoSuggested as Suggested };
